import React from "react";
import Primitives from "../../../components/primitives";
const SmartbuyTrademark = () => (
  <Primitives.Flex>
    <img width="140px" height="auto" src={require("./sbLogo.png")} />
  </Primitives.Flex>
);
export default SmartbuyTrademark;
